import anime from "animejs";

const shuffleAnimation = (el) => {
  const randomChar = () => {
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    return possible.charAt(Math.floor(Math.random() * possible.length));
  };

  const mask = (chars, progress) => {
    const masked = [];
    for (let i = 0; i < chars.length; i++) {
      const position = (i + 1) / chars.length;
      if (position > progress) {
        masked.push(randomChar());
      } else {
        masked.push(chars[i]);
      }
    }
    return masked.join("");
  };

  const chars = el.textContent.split("");
  const params = { progress: 0 };
  const a = anime({
    targets: params,
    progress: 1,
    delay: 200,
    duration: 800,
    easing: "easeInQuad",
    update: () => {
      el.textContent = mask(chars, params.progress);
    },
    complete: () => {
      el.classList.add("completed");
    },
  });
  el.onclick = () => {
    el.classList.remove("completed");
    a.restart();
  };

  // Return a cleanup function if needed
  return () => {
    el.onclick = null;
    el.classList.remove("completed");
  };
};

export default shuffleAnimation;
